<div class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container" [class.next-button-spacing]="!isSubmitted">
    <div class="new-question-para-desc p-0">
      <div class="new-question-para-desc__inner">
        <div class="new-question__container">
          <p class="font-16 font-mob-13 lh-mob-24 lh-30" [froalaView]="element.content"></p>
        </div>
      </div>
    </div>
    <div *ngIf="!isSubmitted" class="next-button-spacing-position">
      <button *ngIf="index>0 && showBackButton" (click)="backHandler()"
        class="btn btn-about btn-outline-primary long-btn70 me-4"><span>BACK</span></button>
      <button (click)="next()" class="btn btn-primary long-btn70"><span>NEXT</span></button>
    </div>
  </div>
</div>
